import { useBackground } from "&/background";
import { changeAppStatusColor } from "%/message";
import { useLayoutEffect } from "react";
interface UseAppColorProps {
  background?: string;
}
export const useAppColor = ({ background }: UseAppColorProps) => {
  const { changeBackround } = useBackground();
  useLayoutEffect(() => {
    if (!background) return;
    changeBackround(background);
    changeAppStatusColor(background);
    return () => {
      changeBackround("#fff");
      changeAppStatusColor("#fff");
    };
  }, [changeBackround, background]);
};
